"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeCountryCode = sanitizeCountryCode;
exports.isGDPRCountry = isGDPRCountry;
exports.isDACHCountry = isDACHCountry;
exports.isGBCountry = isGBCountry;
exports.isUSTerritory = isUSTerritory;
exports.isEUCountry = isEUCountry;
exports.isEUDC = isEUDC;
exports.isEUSubdomain = isEUSubdomain;
exports.getEUCountries = getEUCountries;
exports.getCookieTransportTLDs = getCookieTransportTLDs;
exports.getAudienceSupportedCountries = getAudienceSupportedCountries;
exports.getBenchmarksSupportedCountries = getBenchmarksSupportedCountries;
exports.getSMSupportedCountries = getSMSupportedCountries;
exports.getSiteSupportedLanguages = getSiteSupportedLanguages;
exports.getLanguageCodeFromCountryCode = getLanguageCodeFromCountryCode;
exports.getLanguageCodeFromSubdomain = getLanguageCodeFromSubdomain;
exports.getSubdomainFromLanguageCodeAndDataCenter = getSubdomainFromLanguageCodeAndDataCenter;
exports.getSiteSupportedLanguageCodes = getSiteSupportedLanguageCodes;
exports.getTldLanguageInfo = getTldLanguageInfo;
Object.defineProperty(exports, "LANGUAGES_BY_CODE", {
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES_BY_CODE;
  }
});
Object.defineProperty(exports, "LANGUAGES_BY_ID", {
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES_BY_ID;
  }
});
Object.defineProperty(exports, "LANGUAGES", {
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES;
  }
});
Object.defineProperty(exports, "getDataCenterById", {
  enumerable: true,
  get: function get() {
    return _dataCenters.getDataCenterById;
  }
});
Object.defineProperty(exports, "getDataCenterIdFromCurrentUrl", {
  enumerable: true,
  get: function get() {
    return _dataCenters.getDataCenterIdFromCurrentUrl;
  }
});
Object.defineProperty(exports, "getDefaultSubdomainForDataCenter", {
  enumerable: true,
  get: function get() {
    return _dataCenters.getDefaultSubdomainForDataCenter;
  }
});
exports.localeSets = void 0;

var _invariant = _interopRequireDefault(require("invariant"));

var _tlds = _interopRequireDefault(require("./data/tlds.json"));

var _localeSets = require("./localeSets");

var _languages = require("./languages");

var _dataCenters = require("./dataCenters");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // This is for backward compatibility. Remove for 2.0


var localeSets = {
  GDPR_COUNTRIES: _localeSets.GDPRCountryCodes,
  SM_SUPPORTED_COUNTRIES: _localeSets.SMSupportedCountryCodes,
  EU_COUNTRIES: _localeSets.EUCountryCodes,
  US_TERRITORIES: _localeSets.USTerritoryCountryCodes,
  GB_COUNTRIES: _localeSets.GBCountryCodes,
  DASH_COUNTRIES: _localeSets.DASHCountryCodes
};
exports.localeSets = localeSets;
/**
 * @param {string} country - code
 * @param {string} fallBackCountry - default country code
 * @returns {string} two letter country code, default to US if a fallback is not provided
 */

function sanitizeCountryCode(country) {
  var fallBackCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _localeSets.CountryCodes.US;
  var isString = typeof country === 'string';

  if (!isString) {
    // TODO log this
    !false ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Country code is not a string.') : invariant(false) : void 0;
    return fallBackCountry;
  }

  var isTwoLetterCode = country.length === 2;

  if (!isTwoLetterCode) {
    // TODO log this
    !false ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Country code is not a 2 letter code') : invariant(false) : void 0;
    return fallBackCountry;
  }

  return _localeSets.SMSupportedCountryCodes.find(function (c) {
    return c === country.toUpperCase();
  }) || fallBackCountry.toUpperCase();
}
/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if that country has GDPR laws
 */


function isGDPRCountry(country) {
  // if we cannot determine the country, assume GDPR country ie GB
  return _localeSets.GDPRCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}
/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in DASH country set
 */


function isDACHCountry(country) {
  // if we cannot determine the country, assume non Dash ie. US
  return _localeSets.DASHCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.US));
}
/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in the United Kingdoms
 * @public
 */


function isGBCountry(country) {
  // if we cannot determine the country, assume GB country
  return _localeSets.GBCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}
/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is a US Territory
 * @public
 */


function isUSTerritory(country) {
  // if we cannot determine the country, assume Non US
  return _localeSets.USTerritoryCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}
/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in European Union
 * @public
 */


function isEUCountry(country) {
  // if we cannot determine the country, assume EU. (joelm: WHY?!?!?!)
  return _localeSets.EUCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}
/**
 * @param {string} hostname
 * @returns {bool} if host is a EUDC
 * @public
 */


function isEUDC(hostname) {
  return (0, _dataCenters.getDataCenterIdFromCurrentUrl)(hostname) === _dataCenters.DataCenterIds.EU;
}
/**
 * @param {string} subdomain
 * @returns {bool} if EU Subdomain
 * @public
 */


function isEUSubdomain(subdomain) {
  return !!(subdomain && subdomain.indexOf('eu') !== -1);
}
/**
 * @returns {Array} list of European Union Countries
 * @public
 */


function getEUCountries() {
  return _toConsumableArray(_localeSets.EUCountryCodes);
}
/**
 * @returns {Array} List of SM supported TLDs
 * @public
 */


function getCookieTransportTLDs() {
  return _tlds.default.filter(function (tld) {
    return tld.enabled;
  }).map(function (tld) {
    return tld.tld;
  });
}
/**
 * @returns {Array} Countries that SM Audience supports
 * @public
 */


function getAudienceSupportedCountries() {
  // TODO change this to just return list of country codes
  return {
    US: 'United States',
    AU: 'Australia',
    CA: 'Canada',
    NZ: 'New Zealand',
    SG: 'Singapore',
    GB: 'United Kingdom',
    IE: 'Ireland'
  };
}
/**
 * @returns {Array} Countries that SM Benchmarks supports
 * @public
 */


function getBenchmarksSupportedCountries() {
  // TODO change this to jst return a list of country codes
  return {
    US: 'United States'
  };
}
/**
 * @returns {Array} Countries that SM supports
 * @public
 */


function getSMSupportedCountries() {
  return _toConsumableArray(_localeSets.SMSupportedCountryCodes);
}
/**
 * @returns {Object} Language Object that SM Supports
 * @public
 */


function getSiteSupportedLanguages() {
  return _languages.LANGUAGES.filter(function (language) {
    return language.supportLevel === _languages.SupportLevels.SITE_WIDE;
  });
}
/**
 * @param {string} country - Two-letter country code
 * @returns {string} language code
 */


function getLanguageCodeFromCountryCode(country) {
  var language = _languages.LANGUAGES.find(function (lang) {
    return lang.countries.includes(sanitizeCountryCode(country));
  });

  return language ? language.code : 'en';
}
/**
 * Returns the language code from the subdomain
 * @param {string} subdomain
 * @returns {string} language code
 */


function getLanguageCodeFromSubdomain(subdomain) {
  if (subdomain === 'eu' || subdomain === 'www') {
    return 'en';
  }

  var language = _languages.LANGUAGES_WITH_SUBDOMAINS.find(function (lang) {
    return lang.subdomain === subdomain || "".concat(lang.subdomain, ".eu") === subdomain;
  });

  if (language) {
    return language.code;
  }

  return 'en';
}
/**
 * Returns the subdomain from the language code and data center combination
 * @param {string} languageCode
 * @param {string} dataCenterId
 * @returns {string} subdomain
 */


function getSubdomainFromLanguageCodeAndDataCenter(languageCode, dataCenterId) {
  var language = _languages.LANGUAGES_BY_CODE[languageCode];
  var result = language.subdomain;

  if (dataCenterId === _dataCenters.DataCenterIds.EU) {
    result = "".concat(language.subdomain, ".eu");
  } else if (language.tld === language.subdomain) {
    // override for langs like de and ru which have a cctld
    // only affects www.sm.de || www.sm.ru
    result = 'www';
  }

  return result === 'www.eu' ? 'eu' : result;
}
/**
 * @returns {Array} Language codes that SM Supports
 * @public
 */


function getSiteSupportedLanguageCodes() {
  return getSiteSupportedLanguages().map(function (language) {
    return language.code;
  });
}
/**
 * Returns the tld language info
 * @param {string} tld
 * @returns {string} language info
 */


function getTldLanguageInfo(tld) {
  var data = _tlds.default.find(function (i) {
    return i.tld === tld;
  });

  if (!data) {
    return _tlds.default.find(function (i) {
      return i.tld === 'com';
    });
  }

  return data;
}